import {
    Component,
    Prop,
    h,
    Host,
} from "@stencil/core";

@Component({
    tag: "c-form-progress",
    styleUrl: "c-form-progress.scss",
})
export class CFormProgress {
    @Prop() type: string;
    @Prop() stage?: string;
    @Prop() language: string = "Deutsch";

    buildProgress = (type: string, lang: string) => {
        if (type === "vertical") {
            if (lang === "ua") {
                return (
                    <div class="vertical-svg-container">
                        <span class="people">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <path
                                    class="st0"
                                    d="M71.3,67.3c-0.4,0-10.5-0.4-10.7-12.6c0.3-0.2,0.5-0.5,0.8-0.7c7.2-7.4,6.7-21.8,6.5-28.8c0-0.5,0-1,0-1.5
	c-0.2-8.8-4.8-13-8.6-15c-4.2-2.2-8.5-2.3-9.3-2.3c-1.8,0-17.5,0.5-17.9,17.3c0,0.5,0,1,0,1.6c-0.2,6.9-0.7,21.3,6.4,28.6
	c0.3,0.3,0.7,0.7,1,1C39.1,66.5,29,67.2,28.6,67.3c-15,0-27.2,12.2-27.2,27.2l0,1.5h97.1v-1.5C98.5,79.5,86.3,67.3,71.3,67.3z
	 M35,25.4c0-0.6,0-1.1,0-1.6c0.1-5.9,2.5-10.1,6.9-12.4c3.5-1.9,7.3-1.9,8-1.9c0.7,0,4.4,0.1,7.9,2c4.5,2.4,6.8,6.5,7,12.4
	c0,0.4,0,1,0,1.5c0.2,6.5,0.6,20.1-5.7,26.6c-2.4,2.4-5.4,3.6-9.3,3.6c-3.9,0-7-1.2-9.4-3.6C34.3,45.4,34.8,31.9,35,25.4z M4.4,93
	c0.8-12.7,11.4-22.7,24.3-22.7c0.1,0,12.2-0.8,13.6-13.5c2.2,1.1,4.8,1.7,7.6,1.7c2.9,0,5.5-0.6,7.8-1.8
	C59,69.9,71.1,70.3,71.3,70.3c12.9,0,23.4,10.1,24.2,22.7H4.4z"
                                />
                            </svg>
                            <h3>Персональна інформація</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="document">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <g>
                                    <path
                                        d="M66,45c0-5-4.1-9.1-9.2-9.1c-0.5,0-2.7-0.3-2.9-3.2c0,0,0.1-0.1,0.1-0.1c2.4-2.5,2.3-7.2,2.2-9.4l0-0.5c-0.1-4.7-4-6-6.2-6
		c-2.3,0-6.1,1.3-6.2,6l0,0.5c-0.1,2.2-0.2,6.9,2.2,9.4c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,2.9-2.7,3.2-2.9,3.2C38.1,35.9,34,40,34,45
		l0,1h32V45z M45.7,23.2l0-0.5c0.1-3.7,3.3-4,4.2-4c0.7,0,4.1,0.2,4.2,4l0,0.5c0.1,2,0.2,6.1-1.6,8c-0.6,0.7-1.5,1-2.6,1
		c-1.1,0-2-0.3-2.6-1C45.5,29.3,45.7,25.2,45.7,23.2z M36.1,44c0.5-3.5,3.5-6.1,7.2-6.1c1.5-0.1,4.1-1,4.7-4.1
		c0.6,0.2,1.3,0.3,2,0.3c0.8,0,1.4-0.1,2.1-0.4c0.6,3.1,3.2,4,4.7,4.1c3.6,0,6.6,2.7,7.1,6.1H36.1z"
                                    />
                                    <path
                                        d="M80.5,2h-61C17.6,2,16,3.6,16,5.5v89c0,1.9,1.6,3.5,3.5,3.5h61c1.9,0,3.5-1.6,3.5-3.5v-89C84,3.6,82.4,2,80.5,2z M81,94.5
		c0,0.3-0.2,0.5-0.5,0.5h-61c-0.3,0-0.5-0.2-0.5-0.5v-89C19,5.2,19.2,5,19.5,5h61C80.8,5,81,5.2,81,5.5V94.5z"
                                    />
                                    <path d="M70,56H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,56,70,56z" />
                                    <path d="M70,69H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,69,70,69z" />
                                    <path d="M70,82H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,82,70,82z" />
                                </g>
                            </svg>
                            <h3>Інформація про статус проживання</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="education">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <g>
                                    <path
                                        class="st0"
                                        d="M93.5,26H83V12.5C83,8.9,80.1,6,76.5,6h-53C19.9,6,17,8.9,17,12.5V26H6.5C4,26,2,28,2,30.5v57
		C2,90,4,92,6.5,92h87c2.5,0,4.5-2,4.5-4.5v-57C98,28,96,26,93.5,26z M46,70h8v4c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V70z M16,68
		c-2.2,0-4-1.8-4-4V29h76v35c0,2.2-1.8,4-4,4H16z M74,26H26V15c0-0.6,0.4-1,1-1h46c0.6,0,1,0.4,1,1V26z M20,12.5
		c0-1.9,1.6-3.5,3.5-3.5h53c1.9,0,3.5,1.6,3.5,3.5V26h-4V15c0-1.7-1.3-3-3-3H27c-1.7,0-3,1.3-3,3v11h-4V12.5z M95,87.5
		c0,0.8-0.7,1.5-1.5,1.5h-87C5.7,89,5,88.3,5,87.5v-57C5,29.7,5.7,29,6.5,29H10v35c0,3.3,2.7,6,6,6h28v4c0,2.2,1.8,4,4,4h4
		c2.2,0,4-1.8,4-4v-4h28c3.3,0,6-2.7,6-6V29h3.5c0.8,0,1.5,0.7,1.5,1.5V87.5z"
                                    />
                                    <path
                                        class="st0"
                                        d="M52,44h-4c-2.2,0-4,1.8-4,4v13c0,2.2,1.8,4,4,4h4c2.2,0,4-1.8,4-4V48C56,45.8,54.2,44,52,44z M54,61
		c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V48c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2V61z"
                                    />
                                </g>
                            </svg>
                            <h3>Інформація про освіту та професію</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="language">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <path
                                    class="st0"
                                    d="M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M51,31
	c7-0.1,13.8-1,19.8-2.8c1.9,6.2,3.1,13.2,3.2,20.8H51V31z M51,29V6c8.1,0.6,15.1,8.5,19.2,20.3C64.3,28,57.8,28.9,51,29z M49,29
	c-6.8-0.1-13.3-1-19.2-2.7C33.9,14.6,40.9,6.7,49,6V29z M49,31v18H26c0.1-7.6,1.2-14.6,3.2-20.8C35.2,29.9,42,30.9,49,31z M24,49
	H5.5c0.2-10.2,3.9-19.5,9.8-26.9c3.5,2.2,7.5,4.1,11.9,5.5C25.3,34,24.1,41.3,24,49z M24,51c0.1,7.7,1.3,15,3.3,21.4
	c-4.5,1.4-8.5,3.3-11.9,5.5c-6-7.4-9.6-16.7-9.8-26.9H24z M26,51h23v18c-7,0.1-13.8,1-19.8,2.8C27.2,65.6,26.1,58.6,26,51z M49,71
	V94c-8.1-0.6-15.1-8.5-19.2-20.3C35.7,72,42.2,71.1,49,71z M51,71c6.8,0.1,13.3,1,19.2,2.7C66.1,85.4,59.1,93.3,51,94V71z M51,69V51
	h23c-0.1,7.6-1.2,14.6-3.2,20.8C64.8,70.1,58,69.1,51,69z M76,51h18.5c-0.2,10.2-3.9,19.5-9.8,26.9c-3.5-2.2-7.5-4.1-11.9-5.5
	C74.7,66,75.9,58.7,76,51z M76,49c-0.1-7.7-1.3-15-3.3-21.4c4.5-1.4,8.5-3.3,11.9-5.5c6,7.4,9.6,16.7,9.8,26.9H76z M83.4,20.6
	c-3.3,2.1-7.1,3.8-11.3,5.2C68.9,16.6,63.9,9.6,58,6.2C68,8.1,76.9,13.2,83.4,20.6z M42,6.2c-5.9,3.4-10.9,10.4-14.1,19.5
	c-4.2-1.3-8-3.1-11.3-5.2C23.1,13.2,32,8.1,42,6.2z M16.6,79.4c3.3-2.1,7.1-3.8,11.3-5.2c3.2,9.1,8.2,16.1,14.1,19.5
	C32,91.9,23.1,86.8,16.6,79.4z M58,93.8c5.9-3.4,10.9-10.4,14.1-19.5c4.2,1.3,8,3.1,11.3,5.2C76.9,86.8,68,91.9,58,93.8z"
                                />
                            </svg>
                            <h3>Знання мов</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="finish">
                            <svg
                                version="1.0"
                                id="Ebene_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                            <h3>Закриття</h3>
                        </span>
                    </div>
                );
            } else {
                return (
                    <div class="vertical-svg-container">
                        <span class="people">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <path
                                    class="st0"
                                    d="M71.3,67.3c-0.4,0-10.5-0.4-10.7-12.6c0.3-0.2,0.5-0.5,0.8-0.7c7.2-7.4,6.7-21.8,6.5-28.8c0-0.5,0-1,0-1.5
	c-0.2-8.8-4.8-13-8.6-15c-4.2-2.2-8.5-2.3-9.3-2.3c-1.8,0-17.5,0.5-17.9,17.3c0,0.5,0,1,0,1.6c-0.2,6.9-0.7,21.3,6.4,28.6
	c0.3,0.3,0.7,0.7,1,1C39.1,66.5,29,67.2,28.6,67.3c-15,0-27.2,12.2-27.2,27.2l0,1.5h97.1v-1.5C98.5,79.5,86.3,67.3,71.3,67.3z
	 M35,25.4c0-0.6,0-1.1,0-1.6c0.1-5.9,2.5-10.1,6.9-12.4c3.5-1.9,7.3-1.9,8-1.9c0.7,0,4.4,0.1,7.9,2c4.5,2.4,6.8,6.5,7,12.4
	c0,0.4,0,1,0,1.5c0.2,6.5,0.6,20.1-5.7,26.6c-2.4,2.4-5.4,3.6-9.3,3.6c-3.9,0-7-1.2-9.4-3.6C34.3,45.4,34.8,31.9,35,25.4z M4.4,93
	c0.8-12.7,11.4-22.7,24.3-22.7c0.1,0,12.2-0.8,13.6-13.5c2.2,1.1,4.8,1.7,7.6,1.7c2.9,0,5.5-0.6,7.8-1.8
	C59,69.9,71.1,70.3,71.3,70.3c12.9,0,23.4,10.1,24.2,22.7H4.4z"
                                />
                            </svg>
                            <h3>Persönliche Angaben</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="document">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <g>
                                    <path
                                        d="M66,45c0-5-4.1-9.1-9.2-9.1c-0.5,0-2.7-0.3-2.9-3.2c0,0,0.1-0.1,0.1-0.1c2.4-2.5,2.3-7.2,2.2-9.4l0-0.5c-0.1-4.7-4-6-6.2-6
		c-2.3,0-6.1,1.3-6.2,6l0,0.5c-0.1,2.2-0.2,6.9,2.2,9.4c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,2.9-2.7,3.2-2.9,3.2C38.1,35.9,34,40,34,45
		l0,1h32V45z M45.7,23.2l0-0.5c0.1-3.7,3.3-4,4.2-4c0.7,0,4.1,0.2,4.2,4l0,0.5c0.1,2,0.2,6.1-1.6,8c-0.6,0.7-1.5,1-2.6,1
		c-1.1,0-2-0.3-2.6-1C45.5,29.3,45.7,25.2,45.7,23.2z M36.1,44c0.5-3.5,3.5-6.1,7.2-6.1c1.5-0.1,4.1-1,4.7-4.1
		c0.6,0.2,1.3,0.3,2,0.3c0.8,0,1.4-0.1,2.1-0.4c0.6,3.1,3.2,4,4.7,4.1c3.6,0,6.6,2.7,7.1,6.1H36.1z"
                                    />
                                    <path
                                        d="M80.5,2h-61C17.6,2,16,3.6,16,5.5v89c0,1.9,1.6,3.5,3.5,3.5h61c1.9,0,3.5-1.6,3.5-3.5v-89C84,3.6,82.4,2,80.5,2z M81,94.5
		c0,0.3-0.2,0.5-0.5,0.5h-61c-0.3,0-0.5-0.2-0.5-0.5v-89C19,5.2,19.2,5,19.5,5h61C80.8,5,81,5.2,81,5.5V94.5z"
                                    />
                                    <path d="M70,56H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,56,70,56z" />
                                    <path d="M70,69H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,69,70,69z" />
                                    <path d="M70,82H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,82,70,82z" />
                                </g>
                            </svg>
                            <h3>Angaben zum Aufenthaltsstatus</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="education">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <g>
                                    <path
                                        class="st0"
                                        d="M93.5,26H83V12.5C83,8.9,80.1,6,76.5,6h-53C19.9,6,17,8.9,17,12.5V26H6.5C4,26,2,28,2,30.5v57
		C2,90,4,92,6.5,92h87c2.5,0,4.5-2,4.5-4.5v-57C98,28,96,26,93.5,26z M46,70h8v4c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V70z M16,68
		c-2.2,0-4-1.8-4-4V29h76v35c0,2.2-1.8,4-4,4H16z M74,26H26V15c0-0.6,0.4-1,1-1h46c0.6,0,1,0.4,1,1V26z M20,12.5
		c0-1.9,1.6-3.5,3.5-3.5h53c1.9,0,3.5,1.6,3.5,3.5V26h-4V15c0-1.7-1.3-3-3-3H27c-1.7,0-3,1.3-3,3v11h-4V12.5z M95,87.5
		c0,0.8-0.7,1.5-1.5,1.5h-87C5.7,89,5,88.3,5,87.5v-57C5,29.7,5.7,29,6.5,29H10v35c0,3.3,2.7,6,6,6h28v4c0,2.2,1.8,4,4,4h4
		c2.2,0,4-1.8,4-4v-4h28c3.3,0,6-2.7,6-6V29h3.5c0.8,0,1.5,0.7,1.5,1.5V87.5z"
                                    />
                                    <path
                                        class="st0"
                                        d="M52,44h-4c-2.2,0-4,1.8-4,4v13c0,2.2,1.8,4,4,4h4c2.2,0,4-1.8,4-4V48C56,45.8,54.2,44,52,44z M54,61
		c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V48c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2V61z"
                                    />
                                </g>
                            </svg>
                            <h3>Schulische & Berufliche Angaben</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="language">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-25 -25 150 150"
                            >
                                <path
                                    class="st0"
                                    d="M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M51,31
	c7-0.1,13.8-1,19.8-2.8c1.9,6.2,3.1,13.2,3.2,20.8H51V31z M51,29V6c8.1,0.6,15.1,8.5,19.2,20.3C64.3,28,57.8,28.9,51,29z M49,29
	c-6.8-0.1-13.3-1-19.2-2.7C33.9,14.6,40.9,6.7,49,6V29z M49,31v18H26c0.1-7.6,1.2-14.6,3.2-20.8C35.2,29.9,42,30.9,49,31z M24,49
	H5.5c0.2-10.2,3.9-19.5,9.8-26.9c3.5,2.2,7.5,4.1,11.9,5.5C25.3,34,24.1,41.3,24,49z M24,51c0.1,7.7,1.3,15,3.3,21.4
	c-4.5,1.4-8.5,3.3-11.9,5.5c-6-7.4-9.6-16.7-9.8-26.9H24z M26,51h23v18c-7,0.1-13.8,1-19.8,2.8C27.2,65.6,26.1,58.6,26,51z M49,71
	V94c-8.1-0.6-15.1-8.5-19.2-20.3C35.7,72,42.2,71.1,49,71z M51,71c6.8,0.1,13.3,1,19.2,2.7C66.1,85.4,59.1,93.3,51,94V71z M51,69V51
	h23c-0.1,7.6-1.2,14.6-3.2,20.8C64.8,70.1,58,69.1,51,69z M76,51h18.5c-0.2,10.2-3.9,19.5-9.8,26.9c-3.5-2.2-7.5-4.1-11.9-5.5
	C74.7,66,75.9,58.7,76,51z M76,49c-0.1-7.7-1.3-15-3.3-21.4c4.5-1.4,8.5-3.3,11.9-5.5c6,7.4,9.6,16.7,9.8,26.9H76z M83.4,20.6
	c-3.3,2.1-7.1,3.8-11.3,5.2C68.9,16.6,63.9,9.6,58,6.2C68,8.1,76.9,13.2,83.4,20.6z M42,6.2c-5.9,3.4-10.9,10.4-14.1,19.5
	c-4.2-1.3-8-3.1-11.3-5.2C23.1,13.2,32,8.1,42,6.2z M16.6,79.4c3.3-2.1,7.1-3.8,11.3-5.2c3.2,9.1,8.2,16.1,14.1,19.5
	C32,91.9,23.1,86.8,16.6,79.4z M58,93.8c5.9-3.4,10.9-10.4,14.1-19.5c4.2,1.3,8,3.1,11.3,5.2C76.9,86.8,68,91.9,58,93.8z"
                                />
                            </svg>
                            <h3>Sprachkenntnisse</h3>
                        </span>
                        <span class="vr-line"></span>
                        <span class="finish">
                            <svg
                                version="1.0"
                                id="Ebene_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                            <h3>Abschluss</h3>
                        </span>
                    </div>
                );
            }
        } else {
            let styleClass;
            switch (this.stage) {
                case "Personal":
                    {
                        // ID = SVG1
                        styleClass = "SVG1";
                    }
                    break;
                case "Document":
                    {
                        // ID = SVG2
                        styleClass = "SVG1F SVG2";
                    }
                    break;
                case "Education":
                    {
                        // ID = SVG3
                        styleClass = "SVG1F SVG2F SVG3";
                    }
                    break;
                case "Language":
                    {
                        // ID = SVG4
                        styleClass = "SVG1F SVG2F SVG3F SVG4";
                    }
                    break;
                case "Finish":
                    {
                        // ID = SVG
                        styleClass = "SVG1F SVG2F SVG3F SVG4F SVG5F";
                    }
                    break;
            }
            return (
                <div class="horizontal-svg-container">
                    <span>
                        <svg
                            class={
                                styleClass.includes(1)
                                    ? styleClass.includes("1F")
                                        ? "SVG1F"
                                        : "SVG1"
                                    : ""
                            }
                            version="1.1"
                            id="SVG1"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="-25 -25 150 150"
                        >
                            <path
                                class="st0"
                                d="M71.3,67.3c-0.4,0-10.5-0.4-10.7-12.6c0.3-0.2,0.5-0.5,0.8-0.7c7.2-7.4,6.7-21.8,6.5-28.8c0-0.5,0-1,0-1.5
	c-0.2-8.8-4.8-13-8.6-15c-4.2-2.2-8.5-2.3-9.3-2.3c-1.8,0-17.5,0.5-17.9,17.3c0,0.5,0,1,0,1.6c-0.2,6.9-0.7,21.3,6.4,28.6
	c0.3,0.3,0.7,0.7,1,1C39.1,66.5,29,67.2,28.6,67.3c-15,0-27.2,12.2-27.2,27.2l0,1.5h97.1v-1.5C98.5,79.5,86.3,67.3,71.3,67.3z
	 M35,25.4c0-0.6,0-1.1,0-1.6c0.1-5.9,2.5-10.1,6.9-12.4c3.5-1.9,7.3-1.9,8-1.9c0.7,0,4.4,0.1,7.9,2c4.5,2.4,6.8,6.5,7,12.4
	c0,0.4,0,1,0,1.5c0.2,6.5,0.6,20.1-5.7,26.6c-2.4,2.4-5.4,3.6-9.3,3.6c-3.9,0-7-1.2-9.4-3.6C34.3,45.4,34.8,31.9,35,25.4z M4.4,93
	c0.8-12.7,11.4-22.7,24.3-22.7c0.1,0,12.2-0.8,13.6-13.5c2.2,1.1,4.8,1.7,7.6,1.7c2.9,0,5.5-0.6,7.8-1.8
	C59,69.9,71.1,70.3,71.3,70.3c12.9,0,23.4,10.1,24.2,22.7H4.4z"
                            />
                        </svg>
                        {styleClass.includes("1F") && (
                            <svg
                                class="greenCheck"
                                version="1.0"
                                id="GC"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                        )}
                    </span>
                    <span class="hr-line"></span>
                    <span>
                        <svg
                            class={
                                styleClass.includes(2)
                                    ? styleClass.includes("2F")
                                        ? "SVG2F"
                                        : "SVG2"
                                    : ""
                            }
                            version="1.1"
                            id="SVG2"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="-25 -25 150 150"
                        >
                            <g>
                                <path
                                    d="M66,45c0-5-4.1-9.1-9.2-9.1c-0.5,0-2.7-0.3-2.9-3.2c0,0,0.1-0.1,0.1-0.1c2.4-2.5,2.3-7.2,2.2-9.4l0-0.5c-0.1-4.7-4-6-6.2-6
		c-2.3,0-6.1,1.3-6.2,6l0,0.5c-0.1,2.2-0.2,6.9,2.2,9.4c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,2.9-2.7,3.2-2.9,3.2C38.1,35.9,34,40,34,45
		l0,1h32V45z M45.7,23.2l0-0.5c0.1-3.7,3.3-4,4.2-4c0.7,0,4.1,0.2,4.2,4l0,0.5c0.1,2,0.2,6.1-1.6,8c-0.6,0.7-1.5,1-2.6,1
		c-1.1,0-2-0.3-2.6-1C45.5,29.3,45.7,25.2,45.7,23.2z M36.1,44c0.5-3.5,3.5-6.1,7.2-6.1c1.5-0.1,4.1-1,4.7-4.1
		c0.6,0.2,1.3,0.3,2,0.3c0.8,0,1.4-0.1,2.1-0.4c0.6,3.1,3.2,4,4.7,4.1c3.6,0,6.6,2.7,7.1,6.1H36.1z"
                                />
                                <path
                                    d="M80.5,2h-61C17.6,2,16,3.6,16,5.5v89c0,1.9,1.6,3.5,3.5,3.5h61c1.9,0,3.5-1.6,3.5-3.5v-89C84,3.6,82.4,2,80.5,2z M81,94.5
		c0,0.3-0.2,0.5-0.5,0.5h-61c-0.3,0-0.5-0.2-0.5-0.5v-89C19,5.2,19.2,5,19.5,5h61C80.8,5,81,5.2,81,5.5V94.5z"
                                />
                                <path d="M70,56H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,56,70,56z" />
                                <path d="M70,69H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,69,70,69z" />
                                <path d="M70,82H30c-0.6,0-1,0.4-1,1s0.4,1,1,1h40c0.6,0,1-0.4,1-1S70.6,82,70,82z" />
                            </g>
                        </svg>
                        {styleClass.includes("2F") && (
                            <svg
                                class="greenCheck"
                                version="1.0"
                                id="GC"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                        )}
                    </span>
                    <span class="hr-line"></span>
                    <span>
                        <svg
                            class={
                                styleClass.includes(3)
                                    ? styleClass.includes("3F")
                                        ? "SVG3F"
                                        : "SVG3"
                                    : ""
                            }
                            version="1.1"
                            id="SVG3"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="-25 -25 150 150"
                        >
                            <g>
                                <path
                                    class="st0"
                                    d="M93.5,26H83V12.5C83,8.9,80.1,6,76.5,6h-53C19.9,6,17,8.9,17,12.5V26H6.5C4,26,2,28,2,30.5v57
		C2,90,4,92,6.5,92h87c2.5,0,4.5-2,4.5-4.5v-57C98,28,96,26,93.5,26z M46,70h8v4c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V70z M16,68
		c-2.2,0-4-1.8-4-4V29h76v35c0,2.2-1.8,4-4,4H16z M74,26H26V15c0-0.6,0.4-1,1-1h46c0.6,0,1,0.4,1,1V26z M20,12.5
		c0-1.9,1.6-3.5,3.5-3.5h53c1.9,0,3.5,1.6,3.5,3.5V26h-4V15c0-1.7-1.3-3-3-3H27c-1.7,0-3,1.3-3,3v11h-4V12.5z M95,87.5
		c0,0.8-0.7,1.5-1.5,1.5h-87C5.7,89,5,88.3,5,87.5v-57C5,29.7,5.7,29,6.5,29H10v35c0,3.3,2.7,6,6,6h28v4c0,2.2,1.8,4,4,4h4
		c2.2,0,4-1.8,4-4v-4h28c3.3,0,6-2.7,6-6V29h3.5c0.8,0,1.5,0.7,1.5,1.5V87.5z"
                                />
                                <path
                                    class="st0"
                                    d="M52,44h-4c-2.2,0-4,1.8-4,4v13c0,2.2,1.8,4,4,4h4c2.2,0,4-1.8,4-4V48C56,45.8,54.2,44,52,44z M54,61
		c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2V48c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2V61z"
                                />
                            </g>
                        </svg>
                        {styleClass.includes("3F") && (
                            <svg
                                class="greenCheck"
                                version="1.0"
                                id="GC"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                        )}
                    </span>
                    <span class="hr-line"></span>
                    <span>
                        <svg
                            class={
                                styleClass.includes(4)
                                    ? styleClass.includes("4F")
                                        ? "SVG4F"
                                        : "SVG4"
                                    : ""
                            }
                            version="1.1"
                            id="SVG4"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="-25 -25 150 150"
                        >
                            <path
                                class="st0"
                                d="M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M51,31
	c7-0.1,13.8-1,19.8-2.8c1.9,6.2,3.1,13.2,3.2,20.8H51V31z M51,29V6c8.1,0.6,15.1,8.5,19.2,20.3C64.3,28,57.8,28.9,51,29z M49,29
	c-6.8-0.1-13.3-1-19.2-2.7C33.9,14.6,40.9,6.7,49,6V29z M49,31v18H26c0.1-7.6,1.2-14.6,3.2-20.8C35.2,29.9,42,30.9,49,31z M24,49
	H5.5c0.2-10.2,3.9-19.5,9.8-26.9c3.5,2.2,7.5,4.1,11.9,5.5C25.3,34,24.1,41.3,24,49z M24,51c0.1,7.7,1.3,15,3.3,21.4
	c-4.5,1.4-8.5,3.3-11.9,5.5c-6-7.4-9.6-16.7-9.8-26.9H24z M26,51h23v18c-7,0.1-13.8,1-19.8,2.8C27.2,65.6,26.1,58.6,26,51z M49,71
	V94c-8.1-0.6-15.1-8.5-19.2-20.3C35.7,72,42.2,71.1,49,71z M51,71c6.8,0.1,13.3,1,19.2,2.7C66.1,85.4,59.1,93.3,51,94V71z M51,69V51
	h23c-0.1,7.6-1.2,14.6-3.2,20.8C64.8,70.1,58,69.1,51,69z M76,51h18.5c-0.2,10.2-3.9,19.5-9.8,26.9c-3.5-2.2-7.5-4.1-11.9-5.5
	C74.7,66,75.9,58.7,76,51z M76,49c-0.1-7.7-1.3-15-3.3-21.4c4.5-1.4,8.5-3.3,11.9-5.5c6,7.4,9.6,16.7,9.8,26.9H76z M83.4,20.6
	c-3.3,2.1-7.1,3.8-11.3,5.2C68.9,16.6,63.9,9.6,58,6.2C68,8.1,76.9,13.2,83.4,20.6z M42,6.2c-5.9,3.4-10.9,10.4-14.1,19.5
	c-4.2-1.3-8-3.1-11.3-5.2C23.1,13.2,32,8.1,42,6.2z M16.6,79.4c3.3-2.1,7.1-3.8,11.3-5.2c3.2,9.1,8.2,16.1,14.1,19.5
	C32,91.9,23.1,86.8,16.6,79.4z M58,93.8c5.9-3.4,10.9-10.4,14.1-19.5c4.2,1.3,8,3.1,11.3,5.2C76.9,86.8,68,91.9,58,93.8z"
                            />
                        </svg>
                        {styleClass.includes("4F") && (
                            <svg
                                class="greenCheck"
                                version="1.0"
                                id="GC"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                        )}
                    </span>
                    <span class="hr-line"></span>
                    <span>
                        <svg
                            class={styleClass.includes("5F") ? "SVG5F" : ""}
                            version="1.0"
                            id="SVG5"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="-3 -4 25 25"
                        >
                            <path
                                d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                            />
                        </svg>
                        {styleClass.includes("5F") && (
                            <svg
                                class="greenCheck"
                                version="1.0"
                                id="GC"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                fill="currentColor"
                                viewBox="-3 -4 25 25"
                            >
                                <path
                                    d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                                />
                            </svg>
                        )}
                    </span>
                </div>
            );
        }
    };

    render() {
        return (
            <Host>
                {this.buildProgress(this.type, this.language)}
            </Host>
        );
    }
}